import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/loading/loading.service';
import { users } from 'src/app/models/Login';
import { QrService } from 'src/app/service/qr.service';
import { StorageService } from 'src/app/service/storage.service';
import { Usuario_List } from 'src/app/models/Usuario';
import { MobileMenuService } from 'src/app/service/mobile-menu.service';

@Component({
  selector: 'app-redireccion',
  templateUrl: './redireccion.component.html',
  styleUrls: ['./redireccion.component.css']
})
export class RedireccionComponent {
    filtro: string = '';
    Usuario_List: Usuario_List[] = [];
    cantidad_registros: number = 0;
    activo_desactivo: string = '';
    user: users | undefined;
    bootstrap: any;

    
  loading$ = this.loadingService.loading$;

  constructor(private modulesService: QrService,
    private storage: StorageService,
    private route: Router,
    private toastr: ToastrService,
    private loadingService: LoadingService,
    public mobileMenu: MobileMenuService) {
  }


    ngOnInit(): void {
    this.loadingService.show();
    const usuarioStorage = this.storage.getUsuarioStorage();
    if (!usuarioStorage || Object.keys(usuarioStorage).length === 0) {
       this.route.navigate(['/login']);
      this.loadingService.hide();
    } else {
      this.Lista_Usuarios();
      this.loadingService.hide();
    }


  }

    Lista_Usuarios() {
    this.cantidad_registros = 0;
    if (this.filtro == '') {
      this.modulesService.Lista_Usuarios('todos').subscribe(
        data => {
          console.log('SALIDA:' + JSON.stringify(data));
          this.Usuario_List = data;
          this.cantidad_registros = data.length;
        }
      )
    } else {
      this.modulesService.Lista_Usuarios(this.filtro).subscribe(
        data => {
          //   console.log('SALIDA:' + JSON.stringify(data));
          this.Usuario_List = data;
          this.cantidad_registros = data.length;
        }
      )
    }

  }

  salir(){
    this.storage.removeUsuarioStorage();
    this.route.navigate(['/login/ingresar']);
  }

}
